
@switch (col.type) {
  @case ('text') {
    {{ col.name.includes('.') ? commonService.getValueFromNestedObject(row, col.name) : row[col.name] }}
  }
  @case ('number') {
    {{ col.name.includes('.') ? commonService.getValueFromNestedObject(row, col.name) : (row[col.name] | number: '1.2-2') }}
  }
  @case (col.type === 'valueAndIcon' || col.type === 'translated' ? col.type : '') {
    <div class="row-inline">
      @if (col.type === 'valueAndIcon' && !col.customIcon) {
        <i [class]="iconCallbackFunction(row)" style="margin: 0 8px"></i>
      }
      @if (col.type === 'valueAndIcon' && col.customIcon) {
        <span [innerHTML]="iconCallbackFunction(row)"> </span>
      }
      @if (!col.whenTranslateUseUpperCase && !col.translatePrevLabel) {
        <span>{{ row[col.name] | translate }}</span>
      }
      @if (col.translatePrevLabel && !col.whenTranslateUseUpperCase) {
        <span>{{ col.translatePrevLabel + row[col.name] | translate }}</span>
      }
      @if (col.translatePrevLabel && col.whenTranslateUseUpperCase) {
        <span>{{ col.translatePrevLabel + row[col.name]?.toUpperCase() | translate }}</span>
      }
    </div>
  }
  @case ('valueAndAvatar') {
    <div class="row-inline">
      <p-avatar class="pr-5" shape="circle" [style]="{ 'background-color': '#C9D4FA' }" [label]="this.commonService.getShortName(labelCallbackFunction(row))"></p-avatar>
      <span>{{ labelCallbackFunction(row) }}</span>
    </div>
  }
  @case ('valueAndImage') {
    <div class="row-inline" [style.padding-inline-start]="tableConfig?.rowGroupOptions && isRowGroup ? '36px' : 'unset'">
      <p-avatar class="pr-5" shape="circle" [image]="row[col.name]"></p-avatar>
      <span>{{ labelCallbackFunction(row) }}</span>
    </div>
  }
  @case ('remainedData') {
    @if (remainedDataHasValue(col.remainedDataConfig.callbackFunction(row), row[col.name])) {
      <div>
        <app-chips-with-remained-data
          [data]="col.remainedDataConfig.callbackFunction(row)"
          [showRemainedDataNumber]="col.remainedDataConfig.remainedNumber"
          [objectKey]="col.remainedDataConfig.key"
          [tooltipByKey]="col.remainedDataConfig.tooltipByKey"
        ></app-chips-with-remained-data>
      </div>
    } @else {
      {{ col.remainedDataConfig.remainedDataNoDataLabel | translate }}
    }
  }
  @case ('timeRange') {
  }
  @case ('dateRange') {
    @let compactRange = dateService.compactPassRange(row[col.name], row[col.notEditableSecondRangeKey]);
    @if (compactRange) {
      <!-- A window that fits inside a day: the two dates would say the same thing twice, so it gets the day once and, under it, the hours it covers. -->
      <div class="compact-range">
        <span>{{ compactRange.day }}</span>
        <span class="compact-range__hours">{{ compactRange.hours }}</span>
      </div>
    } @else {
      <div dir="rtl" class="row-inline">
        @if (dateService.noDateProvided(row[col.notEditableSecondRangeKey])) {
          <span> {{ 'COMMON.TAGS.WITHOUT_ENDING' | translate }} &nbsp;-&nbsp; </span>
        }
        @if (!dateService.noDateProvided(row[col.notEditableSecondRangeKey])) {
          <span>{{
            dateService.convertToLocalDate(row[col.notEditableSecondRangeKey], true) | date: 'dd/MM/yyyy'
          }}</span>
        }
        @if (!dateService.noDateProvided(row[col.notEditableSecondRangeKey])) {
          <span>&nbsp;-&nbsp;</span>
        }
        <span>{{ dateService.convertToLocalDate(row[col.name]) | date: 'dd/MM/yyyy' }}</span>
      </div>
    }
  }
  @case ('dateTimeRangeSplitWithPipe') {
    <div class="row-inline">
      {{ row[col.name] | date: 'dd/MM/yyyy' }} &nbsp;-&nbsp;{{ row[col.notEditableSecondRangeKey] | date: 'dd/MM/yyyy' : dateService.timezone }} &nbsp;|&nbsp;
      {{ row[col.name] | date: 'HH::mm' }} &nbsp;-&nbsp;{{ row[col.notEditableSecondRangeKey] | date: 'HH::mm' }}
    </div>
  }
  @case ('valueFromCallback') {
    {{ col.valueFromCallback(row) }}
  }
  @case ('valueFromCallbackBasedHTML') {
    <div
      [innerHTML]="col.valueFromCallback(row) | safeHtml"
      [pTooltip]="col.tooltipCallback ? col.tooltipCallback(row) : null"
      [tooltipPosition]="col.tooltipPosition || 'top'"
      [escape]="false"
    ></div>
  }
  @case ('icon') {
    @if (col.trueIconClass && col.falseIconClass) {
      <div>
        @if (row[col.name]) {
          <i [class]="col.trueIconClass"></i>
        }
        @if (!row[col.name]) {
          <i [class]="col.falseIconClass"></i>
        }
      </div>
    }
  }
  @case ('date') {
    {{ dateService.convertToLocalDate(row[col.name]) | date: 'dd/MM/yyyy' }}
    @if (col.dateOrTimeAdditionalFormat) {
      {{ row[col.name] | date: col.dateOrTimeAdditionalFormat }}
    }
  }
  @case ('uploader') {
    @if (!getImportTicketsLinkForEvent(row.id).length) {
      <span class="row-inline grid-xsm">
        <span class="cell">
          <app-ticket-uploader-with-icon [id]="row.id" icon="plus" (linkChange)="changeImportTicketsState(row.id, $event)"> </app-ticket-uploader-with-icon>
        </span>
      </span>
    }
    @if (getImportTicketsLinkForEvent(row.id).length) {
      @if (!loadingLink(row.id)) {
        <div class="row-inline">
          <span class="cell"
            ><button type="button" class="btn btn-primary-link active" (click)="importTicketsOnClick(row, $event)">
            <i aria-hidden="true" class="pi pi-check"></i>
          </button>
        </span>
        <span class="cell">
          <button type="button" class="btn btn-danger-link active" (click)="changeImportTicketsState(row.id, '')">
            <i aria-hidden="true" class="pi pi-trash"></i>
          </button>
        </span>
      </div>
    }
    @if (loadingLink(row.id)) {
      <div class="cell">
        <i class="pi pi-spin pi-spinner color-primary" style="font-size: 1rem"></i>
      </div>
    }
  }
}
@case ('avatarGroup') {
  @if (row[col.name]?.length) {
    <p-avatarGroup styleClass="mb-3">
      @for (s of row[col.name].slice(0, 3); track s) {
        <p-avatar
          [label]="this.commonService.getShortName(labelCallbackFunction(row))"
          shape="circle"
          [style]="{ 'background-color': '#9578d3', color: '#ffffff' }"
        ></p-avatar>
      }
      @if (row[col.name]?.length > 3) {
        <p-avatar
          [label]="'+' + row[col.name]?.length"
          shape="circle"
          class="fz-12"
          [pTooltip]="avatarGroupData(row, col)"
          tooltipPosition="bottom"
        ></p-avatar>
      }
    </p-avatarGroup>
  }
  @if (!row[col.name]?.length) {
    <span class="color-gray">{{ 'CLUBS.SUBSCRIBERS.NO_SUBSCRIBERS' | translate }}</span>
  }
}
@case ('knob') {
  <app-myknob [percent]="col.knobConfig.percentValueCallback(row)" type="horizontal_rectangle" status="success" [totalValue]="col.knobConfig.totalValueCallback(row)">
  </app-myknob>
}
@default {
  NONE
}
}
